import { OkeeyCashComponent } from './okeey-cash.component';
import { Routes } from '@angular/router';
import { YourDocumentationComponent } from './your-documentation/your-documentation.component';
import { ReadyToApplyComponent } from './ready-to-apply/ready-to-apply.component';
import { ApplyToOkeeyCashComponent } from './apply-to-okeey-cash/apply-to-okeey-cash.component';
import { TutorialOkeeyCashComponent } from './tutorial-okeey-cash/tutorial-okeey-cash.component';
import { JourneyOkeeyCashComponent } from './journey-okeey-cash/journey-okeey-cash.component';
import { EmployerDepositComponent } from './employer-deposit/employer-deposit.component';
import { MakingDepositComponent } from './making-deposit/making-deposit.component';
import { OkeeyCashBenefitComponent } from './okeey-cash-benefit/okeey-cash-benefit.component';
import { FamilyCardHealthComponent } from './family-card-health/family-card-health.component';
import { UniganaEligibilityComponent } from './unigana-eligibility/unigana-eligibility.component';

export const routes: Routes = [
  { path: '', component: OkeeyCashComponent },
  { path: 'apply', data: { breadcrumb: 'apply' }, component: ApplyToOkeeyCashComponent },
  { path: 'tutorial', data: { breadcrumb: 'tutorial' }, component: TutorialOkeeyCashComponent },
  { path: 'journey', data: { breadcrumb: 'journey' }, component: JourneyOkeeyCashComponent },
  { path: 'employer-deposit', data: { breadcrumb: 'Employer Deposit' }, component: EmployerDepositComponent },
  { path: 'deposit', data: { breadcrumb: 'Making Deposit' }, component: MakingDepositComponent },
  { path: 'benefit', data: { breadcrumb: 'benefit' }, component: OkeeyCashBenefitComponent },
  { path: 'ready-to-apply', component: ReadyToApplyComponent },
  { path: 'documentation', data: { breadcrumb: 'documentation' }, component: YourDocumentationComponent },
  { path: 'family-health', data: { breadcrumb: 'family-health' }, component: FamilyCardHealthComponent },
  { path: 'eligibility', data: { breadcrumb: 'eligibility' }, component: UniganaEligibilityComponent }
];
